import React from 'react';
import { getLocationStatus, formatLastUpdated, canViewEmployeeLocation } from './locationUtils';

// Single employee row rendered inside the virtualized list. `style` comes
// straight from react-window (position: absolute; width: 100%) and must be
// applied to the row's root element — the grid layout below (matching the
// non-virtualized header row) lives on the same element via className.
function LocationRow({ employee, style, onViewLocation }) {
  const locationStatus = getLocationStatus(employee);
  const canView = canViewEmployeeLocation(employee);

  return (
    <div className="employee-row" style={style} role="row">
      <div className="employee-cell" role="cell">{employee.name}</div>
      <div className="employee-cell" role="cell">
        <span className={`status-badge ${employee.status === 'online' ? 'online' : 'offline'}`}>
          {employee.status === 'online' ? '🟢 Online' : '⚫ Offline'}
        </span>
      </div>
      <div className="employee-cell" role="cell">
        <span className={`status-badge ${locationStatus.className}`}>
          {locationStatus.text}
        </span>
      </div>
      <div className="employee-cell" role="cell">{formatLastUpdated(employee.lastUpdated)}</div>
      <div className="employee-cell" role="cell">
        <button
          className="btn-view-location"
          onClick={() => onViewLocation(employee)}
          disabled={!canView}
        >
          {canView ? '📍 View Location' : '🚫 Unavailable'}
        </button>
      </div>
    </div>
  );
}

export default React.memo(LocationRow);
